import { render, staticRenderFns } from "./cover-map.vue?vue&type=template&id=5e67f366"
import script from "./cover-map.vue?vue&type=script&lang=js"
export * from "./cover-map.vue?vue&type=script&lang=js"
import style0 from "./cover-map.vue?vue&type=style&index=0&id=5e67f366&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports